



























































































import mixins from 'vue-typed-mixins';
import { AxiosResponse } from 'axios';
import buildEntityListComponentMixin from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { VendorLotId } from './VendorLotId';
import { ParkingPaymentVendor } from './Enums';
import { ILookupType, LocationLookupType } from '@/Stores/LookupStore';

export default mixins(LocationBasedMixin, buildEntityListComponentMixin<VendorLotId>()).extend({
    props: {
        vendor: {
            required: true,
            type: Number,
        }
    },
    beforeMount() {
        this.$typedStore.modules.lookupsModule.actions
            .getLocationLookups({
                lookupType: LocationLookupType.Location,
                location: this.location
            })
            .then(locations => { this.lotLookups = Object.keys(locations).map(key => locations[key]); });
    },
    data() {
        return {
            i18nPrefix: 'admin.vendorLotIds',
            lotFilter: null as string | null,
            vendorLotFilter: null as string | null,
            lotLookups: [] as ILookupType[],
        };
    },
    computed: {
        entityUrls(): string {
            return `${this.location}/LotMaintenance/VendorLotIds?vendor=${this.vendor}`;
        },
        filteredEntities(): VendorLotId[] {
            let filtered = this.entities;

            if (this.lotFilter) {
                const knownLots = this.lotLookups
                    .filter(item => item.description!.toUpperCase().indexOf(this.lotFilter!.toUpperCase()!) > -1)
                    .map(item => item.code.toUpperCase());
                filtered = filtered.filter(item =>
                    item.lotLkupLotID?.toUpperCase().indexOf(this.lotFilter!.toUpperCase()!) > -1
                    || (knownLots.length && knownLots.includes(item.lotLkupLotID?.toUpperCase()))
                    || (this.editItem && this.editItem.recID === item.recID)
                );
            }

            if (this.vendorLotFilter) {
                filtered = filtered
                    .filter(item => item.vendorLotID?.toUpperCase().indexOf(this.vendorLotFilter!.toUpperCase()) > -1
                        || (this.editItem && this.editItem.recID === item.recID)
                    );
            }

            return filtered;
        },
    },
    methods: {
        afterLoad(response: AxiosResponse<VendorLotId[]>): VendorLotId[] {
            return response.data.sort((a, b) => a.lotLkupLotID.localeCompare(b.lotLkupLotID));
        },
        addVendorLotId() {
            this.add();
            if (this.editItem) {
                this.editItem.vendorID = this.vendor;
            }
        },
    },
    watch: {
        vendor() {
            this.loadEntities();
        }
    }
});
